var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"feature-card-tech-feature-card",class:_vm.rootClassName},[_c('h2',{staticClass:"feature-card-tech-text"},[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"feature-card-tech-text1"},[_vm._v(_vm._s(_vm.description))])])
}
var staticRenderFns = []

export { render, staticRenderFns }